var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bers-product"},[_c('productselect'),_vm._l((_vm.productTypes),function(type,index,key){return _c('div',{key:key,attrs:{"index":index}},[(type.identifier === 'entry_type')?_c('producttype',_vm._b({},'producttype',type,false)):_vm._e()],1)}),_c('producttime'),_c('productcustomer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }